import { Box, Button, IconButton, Typography, styled } from "@mui/material"

export const MainBox = styled(Box)(() => ({
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    boxShadow: "0px 13px 10px -20px #111",
    borderBottom: "1px solid var(--table-border-color)",
    color: "var(--secondary-text-color)",
    marginBottom: "20px",
}))

export const ActiveProjectButton = styled(Button)(({ selectedbutton }) => ({
    fontWeight: "bold",
    borderRadius: "0px",
    color:
        selectedbutton === "Active Projects"
            ? "#338BA8"
            : "var(--secondary-text-color)",
    borderBottom:
        selectedbutton === "Active Projects"
            ? "2px solid #338BA8"
            : "none",
    margin: "0px 5px 0px 5px",
}))


export const ArchivedProjectButton = styled(Button)(({ selectedbutton }) => ({
    fontWeight: "bold",
    borderRadius: "0px",
    color:
        selectedbutton === "DeActive Projects"
            ? "#338BA8"
            : "var(--secondary-text-color)",
    borderBottom:
        selectedbutton === "DeActive Projects"
            ? "2px solid #338BA8"
            : "none",
    margin: "0px 5px 0px 5px",
}))


export const AddProjectBox = styled(Box)(() => ({
    display: "flex",
    alignItems: "center",
    paddingRight: "15px",
    '@media (max-width: 600px)': {
        paddingRight: "0px",
    },
}))

export const LoadingBox = styled(Box)(() => ({
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    height: "65vh",
}))

export const NoDataTypography = styled(Typography)(() => ({
    textTransform: "capitalize",
    userSelect: "none",
}))

export const InnerBoxOne = styled(Box)(() => ({
    margin: "5px 5px 5px 5px",
    cursor: "pointer",
    "&:hover": {
        "& > div": {
            background:
                "var(--primary-highlight-color)",
            color: "var(--primary-color)",
        },
    },
}))

export const InnerBoxTwo = styled(Box)(() => ({
    cursor: "pointer",
    borderRadius: "5px",
    minHeight: "160px",
    height: "18vh",
    background:
        "var(--background-table-sidebar-card-color)",
    padding: "5px 15px 5px 15px",
    display: "flex",
    flexDirection: "column",
    border: "1px solid #ccc",
    color: "var(--secondary-text-color)",
    justifyContent: "center",
    position: "relative",
    "@media (max-width: 600px)": {
        height: "8vh",
        justifyContent: "flex-start",
        minHeight: "100px",
    },
}))

export const SwitchBox = styled(Box)(() => ({
    position: "absolute",
    top: "5px",
    right: "5px",
}))

export const ProjectNameBox = styled(Box)(() => ({
    // Center content horizontally and vertically
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    textAlign: "center",
    "@media (max-width: 600px)": {
        alignItems: "flex-start",
        justifyContent: "flex-start",
        textAlign: "left",
        fontSize: "16px",
    },
}))

export const SideBox = styled(Box)(({ isdarktheme }) => ({
    position: "fixed",
    top: 0,
    right: 0,
    width: "40%",
    height: "100vh",
    background: isdarktheme === "true" ? "#0b1727" : "#ffffff",
    borderRadius: "5px",
    zIndex: 999,
    boxShadow: "0 0 5px rgba(0, 0, 0, 0.1)",
    overflowY: "auto",
    '@media (max-width: 600px)': {
        width: '100%',
    },
}))

export const CloseIconButton = styled(IconButton)(({ isdarktheme }) => ({
    color: isdarktheme === "true" ? "#e0e0e0cc" : "#5e6e82",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    position: "absolute",
    top: "5px",
    right: "-5px",
    fontWeight: "bold",
    textTransform: "capitalize",
    marginRight: "15px",
    fontSize: "2px",
    "&:hover": {
        background: "var(--highlight-color)",
    },
}))

export const InnerBoxThree = styled(Box)(() => ({
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    width: "500px",
    "@media (max-width: 600px)": {
        maxWidth: "100%",
      },
}))

export const InnerBoxFour = styled(Box)(() => ({
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    margin: "35px 0px",
}))

export const InnerBoxFive = styled(Box)(({ isdarktheme }) => ({
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    background: isdarktheme === "true" ? "#ff000046" : "#ff000221",
    borderRadius: "1000px",
    padding: "8px",
    marginRight: "25px",
}))

export const ActiveArchiveButtton = styled(Button)(() => ({
    borderRadius: "5px",
    textTransform: "capitalize",
}))

export const ErrorTypography = styled(Typography)(() => ({
    color: "red",
    marginTop: "20px"
}))

export const CancelButton = styled(Button)(({ isdarktheme }) => ({
    color: isdarktheme === "true" ? "#e0e0e0cc" : "#5e6e82",
    textTransform: "capitalize",
    fontWeight: "bold",
    marginRight: "10px",
    borderRadius: "5px",
}))

export const AddProjectButtonBox = styled(Box)(() => ({
    marginBottom: "20px",
    paddingRight: "15px",
    display: "flex",
    justifyContent: "flex-end",
    '@media (max-width: 600px)': {
        paddingRight: "0px",
    },
}))

export const SliderBox = styled(Box)(() => ({
    "@media (max-width: 600px)": {
        padding: "10px 0px 0px 0px",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        flexGrow: 1,
        overflow: "hidden",
        position: "relative"
    },
}))

export const CommanTabBox = styled(Box)(() => ({
    "@media (max-width: 600px)": {
        display: "flex",
        flexDirection: "row",
        flexShrink: "0",
        minWidth: "100%",
        justifyContent: "center"
    },
}))

export const InnerSliderBox = styled(Box)(() => ({
    display: "flex",
    flexDirection: "row",
    overflowX: "auto",
    "&::-webkit-scrollbar": {
        display: "none",
    },
    overflowY: "hidden",
}))

export const AddProjectButton = styled(Button)(() => ({
    '@media (max-width: 600px)': {
        width: '100%',
    },
}))

export const InnerBoxOneDialog = styled(Box)(() => ({
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
}))

export const InnerBoxTwoDialog = styled(Box)(({ isdarktheme }) => ({
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    background: isdarktheme === "true" ? "#ff000046" : "#ff000221",
    borderRadius: "1000px",
    padding: "8px",
}))